import { landingApi } from '../../api';
import { getMapOffers } from '../../utils/offers';
import { ICalculatorMcfValues } from '../../types/features';
import { useSelector } from 'react-redux';
import { selectUtmTags } from '../../selectors/landing';

export const useGetMappedOffers = (calculatorValues: ICalculatorMcfValues) => {
  const { data, isFetching } = landingApi.endpoints.getOfferListing.useQuery({
    regionId: Number(calculatorValues.region),
    loanTermYears: Number(calculatorValues.loanTerm),
    objectCost: calculatorValues.objectCost,
    downPayment: calculatorValues.downPayment,
    incomeConfirmation: calculatorValues.incomeConfirm,
    realEstateType: calculatorValues.realEstateType,
    objectType: calculatorValues.objectType,
    benefitProgram: calculatorValues.benefitProgram,
    employmentType: calculatorValues.typeOfEmployment,
    payrollBankId: Number(calculatorValues.payrollBank),
  });
  const utmTags = useSelector(selectUtmTags);

  const mappedOffers = data && data.offers ? getMapOffers(data.offers, utmTags) : [];

  return { mappedOffers, isFetching };
};
